import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BiometryService } from 'src/app/services/biometry.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { BiometryFingerPrintComponent } from './biometryFingerprint.component';



@NgModule({
  declarations: [BiometryFingerPrintComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TabsModule
  ],
  providers: [DatePipe, BiometryService, ConfigurationService],
  exports: [BiometryFingerPrintComponent]
})
export class BiometryFingerPrintModule { }
